<div
  class="px-3 pt-3 pb-2 m-0 h-full"
  [ngClass]="{ 'cursor-pointer': numberOfEntities > 0 }"
  [appAlertStyle]="key"
  (click)="setItemsToShow(key)">
  <div class="flex gap-2 pb-2 font-bold align-items-center">
    <i [class]="iconByKey"></i> {{ labelByKey }}
  </div>
  <div class="text-5xl">{{ numberOfEntities }}</div>

  <div class="text-right py-2" *ngIf="numberOfEntities > 0">
    <a>Details <i class="fas fa-arrow-right"></i></a>
  </div>
</div>
